import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export const Orders = () => {
  useEffect(() => {
    document.title = 'PlanOmatic - Orders';

    return () => {
      document.title = 'PlanOmatic';
    };
  }, []);
  return <Outlet />;
};
